import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Form, Button, Icon, Select, message } from 'antd';
import { FormattedMessage } from 'react-intl';
import qs from 'query-string';
import './CareerBuilderEdgeLoginForm.scss';
import config from '../../../Config/Config';
import { getJobBoardErrorDetails } from '../../../Utils/JobBoardUtils';
import messages from '../../../Containers/ManualSearchV2/ManualSearchMessages';
import { setNotification } from '../../../Actions/ActionCreators/ConnectActions';

const { baseUrl, redirectUri, clientId } = config.portal.oauth.careerBuilderEdge;

const mapDispatchToProps = {
  SetNotification: setNotification,
};

class CareerBuilderEdgeLoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // To disabled submit button at the beginning.
    const { form } = this.props;
    form.validateFields();
    window.addEventListener('message', this.callback);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.callback);
  }

  callback = e => {
    const { fetchPortalCredentials, SetNotification } = this.props;
    const { search } = e.data;
    if (!_.isEmpty(search)) {
      const parsed = qs.parseUrl(search);
      const { status } = parsed;
      if (status === 'true') {
        SetNotification('SUCCESS', {
          messageId: 'successfullyConnected',
        });
        fetchPortalCredentials();
      }
    }
  };

  integrate = () => {
    const { currentUser } = this.props;
    const { email } = currentUser;
    const url = `${baseUrl}response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}/careerbuilder&scope=offline_access&state=${email}`;
    window.open(url, '_blank', 'width=800,height=800');
  };

  handleSubmit(isAuthenticated) {
    const { form, jobBoard, disconnect, index, removeSelectedCountry } = this.props;
    const countryCode = form.getFieldValue(`${jobBoard}countryCode`);
    if (isAuthenticated) {
      disconnect(jobBoard, countryCode, index, removeSelectedCountry);
    } else {
      this.integrate();
    }
  }

  render() {
    const { form, jobBoard, portalSettings, account, index, Countries, countriesMenu, isAuthenticated } = this.props;
    const credentials = account;
    const errorDetail = getJobBoardErrorDetails(credentials, jobBoard);
    return (
      <div className="portal-login-form cb-edge-form">
        <div className={isAuthenticated ? 'authentication-tick' : 'authentication-untick'}>
          {isAuthenticated ? <Icon type="check-circle" className="authentication-check-circle" theme="filled" /> : null}
        </div>
        <div className="credentials-container">
          <Form layout="inline">
            <Form.Item>
              <div className="jobboard-country-code">
                {form.getFieldDecorator(`${jobBoard}countryCode`, {
                  initialValue: credentials.CountryCode || (Countries && Countries[0]),
                })(
                  <Select
                    className="jobboard-country-code-select"
                    disabled={isAuthenticated || countriesMenu.length < 2}
                  >
                    {countriesMenu}
                  </Select>
                )}
              </div>
            </Form.Item>

            <Form.Item>
              <div className="authenticate-career">
                <FormattedMessage {...messages.authenticateCareerBuilderWithAryaLabel} />
              </div>
              <div className="authentication">
                <FormattedMessage {...messages.authenticationWillLetYouSeeCandidatesLabel} />
              </div>
            </Form.Item>

            <Form.Item>
              <div className="btn-container">
                <Button
                  // type="primary"
                  className={isAuthenticated ? 'disconnect-button' : 'authenticate-button'}
                  loading={_.get(portalSettings, ['AuthenticationApiStatus', index], '') === 'INPROGRESS'}
                  htmlType="submit"
                  onClick={() => this.handleSubmit(isAuthenticated)}
                  shape="round"
                  block
                >
                  {isAuthenticated ? (
                    <FormattedMessage {...messages.disconnectLabel} />
                  ) : (
                    <FormattedMessage {...messages.authenticateLabel} />
                  )}
                </Button>
              </div>
            </Form.Item>
          </Form>
          <div className="error-message">{errorDetail.Message}</div>
        </div>
      </div>
    );
  }
}

export default connect(null, mapDispatchToProps)(Form.create()(CareerBuilderEdgeLoginForm));
export { CareerBuilderEdgeLoginForm as CareerBuilderEdgeLoginFormWithoutStore };
